// extracted by mini-css-extract-plugin
export default {"container":"SystemOfMeasureSwitch_container__32kzA","radioBtn":"SystemOfMeasureSwitch_radioBtn__uebzi","outlined":"SystemOfMeasureSwitch_outlined__ZrwKe"};